import React from 'react'

import { ResultsForm, UserInfo } from '../components'
import { UserAuth } from '../contexts/AuthContext'
import AnimatedPage from "../utils/AnimatedPage";
import Logo from "../assets/images/logo.svg";

const Results = () => {
  const { user } = UserAuth()

  return (
    <AnimatedPage>
      <img className="mx-auto h-12 w-auto mb-10" src={Logo} alt="logo" />
      {/* {user ? <UserInfo/> : null} */}
      <ResultsForm/>
    </AnimatedPage>
  )
}

export default Results